<template>
    <div>
        <h2></h2>
            <header itemtype="http://schema.org/Person" class="address vcard">
                <section>
                    <a class="url profile" href="/CV.pdf" target="_blank" rel="me author">CV</a>
                    <a class="url profile" target="_blank" href="https://www.linkedin.com/in/mariopedroqueiros" rel="me author">LinkedIn</a>                    
                    <a class="email" target="_blank" href="mailto:mariopqueiros@gmail.com" title="Hangouts">mariopqueiros@gmail.com</a></section>
            </header>
    </div>
</template>

<script>
export default {
  name: "Footer"
};
</script>